import styled from 'styled-components';
import { getSpacingToken, getToken } from '@optimus-web/common';
import { BareIconButton } from '../BareIconButton';
import { Container } from '../Container';
import { Icon } from '../Icon';
import { Stack } from '../Stack';
import { getTypographyOptions, TypographyOptions } from '../typography';
import { getBannerBackgroundColor, getBannerColor } from './getBannerStyles';
import { BannerVariant } from './types';

export const BannerElement = styled(Stack)<{ variant: BannerVariant }>`
    box-sizing: border-box;
    color: ${({ variant }) => getBannerColor(variant)};
    background-color: ${({ variant }) => getBannerBackgroundColor(variant)};
    border-radius: ${getToken('borderRadius100')}px;
    padding: ${getSpacingToken('200')}px;
`;

export const BannerIconElement = styled(Icon)`
    margin-right: ${getSpacingToken('150')}px;
`;

export const LinkContainer = styled(Container)<TypographyOptions>`
    ${getTypographyOptions}
`;

export const BannerCloseButton = styled(BareIconButton)`
    margin-left: ${getSpacingToken('300')}px;
`;
